<template>
  <div>
      <header-item :headerId="headerId"></header-item>
      <div class="company-zt">
         <div class="company-img">
           <img src="../assets/img/ch.jpg" width="376" height="454"/>
         </div>
         <div class="company-text">
            <div class="title-zt">
              <span class="title-l">公司概况</span>
              <span class="title-m">ABOUT US</span>
            </div>
             <div class="company-con">
               <p class="mtp10">点滴传媒隶属于北京点滴畅想传媒有限公司，主要业务包括新闻媒体传播、舆情监测、品牌营销公关、新媒体营销、危机管理、企业宣传片制作、海外媒体传播、行业高端会议、相应的影视品牌植入与传播等，案例遍及快消品、汽车、金融、IT、通信、互联网、消费电子、医疗健康等行业。</p>
               <p class="mtp40">点滴的核心团队均为国内知名公关传播机构、主流媒体以及知名互联网公司的核心人才，深谙全媒体营销策略体系，拥有丰富的策划及传播经验。点滴传媒囊括上千家传统媒体资源和上万家新媒体资源，所拥有的各行业主流媒体资源数量和质量都处于业界领先地位。2018年，点滴传媒在高速发展的同时，依然落实贯彻点滴传媒的宗旨：点滴传媒，畅想未来。致力于为每一位客户提供专业的服务，与客户一同前进</p>
             </div>
             <el-button type="primary" round @click="getDetail">查看详情 <i class="el-icon-right"/></el-button>
         </div>
      </div>
     <div class="service-bj">
       <div class="service-zt">
         <div class="title-zt">
           <span class="title-l">点滴服务</span>
           <span class="title-m">POINTSERVICE</span>
         </div>
         <ul class="service-con">
           <li>
             <img src="../assets/img/news.jpg" width="356" height="166"/>
             <p>
               点滴传媒提供全方位的图文及多媒体发布解决方案，目前已经与包括新浪、搜狐、网易、凤凰、人民、新华、腾讯、金融界等国内上千家知名媒体建立了合作关系，
               覆盖36个行业的企业新闻，并将其作为主要新闻线索来源。
             </p>
           </li>
           <li>
             <img src="../assets/img/world.jpg" width="356" height="166"/>
             <p>
               点滴传媒团队，拥有多年舆情处理经验，与数十家大数据公司精准合作，6000多家的新闻网站，社区，微博，论坛等进行全网监测，出现任何信息，提供一对一客服精准服务，快速反馈。
             </p>
           </li>
           <li>
             <img src="../assets/img/seo.jpg" width="356" height="166"/>
             <p>
               点滴SEO团队成员均来自百度、慧聪网等知名互联网企业，凭借多年的搜索引擎优化经验，建立了专业的三位一体SEO服务模式，并拥有自主研发的搜索引擎优化平台为技术核心，实现以专业+技术双驱动的精准优化体系。
             </p>
           </li>
         </ul>
         <ul class="service-con">
           <li>
             <img src="../assets/img/news1.jpg" width="356" height="166"/>
             <p>
               点滴传媒提供一站式抖音运营服务，专业为客户提供企业视频片，产品拍摄，内容策划，短视频代运营等相关服务，通过短视频平台运营，实现效率的提升，目标客户的精准获取以及品牌多重曝光。
             </p>
           </li>
           <li>
             <img src="../assets/img/news2.jpg" width="356" height="166"/>
             <p>
               点滴传媒是一家国内领先的新媒体内容及运营服务商，拥有包括金融、影视娱乐、时尚、生活、本地、汽车、科技、母婴、健康等九大类别自媒体矩阵，帮助企业主们量身定制新媒体原创内容及运营。点滴传媒矢志成为全国领先的新媒体综合服务商！
             </p>
           </li>
           <li>
             <img src="../assets/img/news3.jpg" width="356" height="166"/>
             <p>
               点滴传媒团队与国内众多媒体，报社等企业建立合作，成为协办方共同承办大型会议，帮助企业领导沟通参会，建立更多的企业合作关系。
             </p>
           </li>
         </ul>
       </div>
     </div>
     <div class="case-bj">
        <div class="case-zt">
          <div class="title-zt">
            <span class="title-l">客户案例</span>
            <span class="title-m">Customer case</span>
          </div>
          <div class="carousel">
            <vue-seamless-scroll :class-option="optionLeft" class="seamless-warp2" :data="tableData">
              <div class="carousel-item" v-for="(item, index) in tableData"
                   :key="index">
                <img :src="item.url" width="158" height="100"/>
                <span>{{item.name}}</span>
              </div>
            </vue-seamless-scroll>
          </div>
          <el-button type="primary" round @click="getCase">更多案例 <i class="el-icon-right"/></el-button>
        </div>
     </div>
    <div class="address-bj">
      <div class="address-zt">
        <span><i class="el-icon-map-location a-icon" />公司地址：北京市房山区良乡凯旋大街建设路18号-D8651</span>
        <span><i class="el-icon-goods a-icon" />公司网址：www.diandicx.cn</span>
      </div>
    </div>
    <div class="footer">Copyright2021 点滴传媒 diandicx.cn All right reserved 版权所有 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;京ICP备2021022076号</div>
    <div style="width:300px;margin:0 auto; padding:20px 0;">
      <a target="_blank" href="" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
        <img src="../assets/img/beian.png" style="float:left;"/>
        <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">京公网安备 11011502006204号</p >
      </a>
    </div>
  </div>
</template>
<script>
  import '../assets/styles/index.scss'
  import HeaderItem from '../components/header.vue'
  import vueSeamlessScroll from 'vue-seamless-scroll'
  export default {
    name: 'index',
    components: {
      vueSeamlessScroll,
      HeaderItem
    },
  data () {
      return {
        tableData:[
          { url: require('@/assets/img/5.1.jpg'),name:'科沃斯' },
          { url: require('@/assets/img/5.2.jpg'),name:'科大讯飞' },
          { url: require('@/assets/img/5.3.jpg'),name:'花生好车' },
          { url: require('@/assets/img/5.4.jpg'),name:'佳兆业' },
          { url: require('@/assets/img/5.5.jpg'),name:'开鑫金服' },
          { url: require('@/assets/img/5.6.jpg'),name:'中科星图' },
          { url: require('@/assets/img/5.7.jpg'),name:'京东' },
        ],
        headerId:'index'
      }
    },
    computed: {
      optionLeft() {
        return {
          step: 1, // 数值越大速度滚动越快
          limitMoveNum: 3, // 开始无缝滚动的数据量 this.dataList.length
          hoverStop: true, // 是否开启鼠标悬停stop
          direction: 2, // 0向下 1向上 2向左 3向右
          openWatch: true, // 开启数据实时监控刷新dom
          singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
          singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
          waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
        };
      },
    },
    mounted() {
    },
    methods:{
      getDetail(){
        this.$router.push({path:"/aboutUs"});
      },
      getCase(){
        this.$router.push({path:"/customer"});
      }
    },
  }
</script>
<style scoped lang="scss">
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
</style>



// WEBPACK FOOTER //
// src/pages/index.vue